const isSubDomainMultitenancyType = process.env.VUE_APP_MULTITENANCY_TYPE === "Subdomain";

const hasProtocol = (protocol?: string) => {
    return protocol && (protocol?.startsWith("https:") || protocol?.startsWith("http:"));
}

const getServerUrlByRelativePath = (relativePath: string) => {
    return location.origin + relativePath;
}

export const getBaseUrlByBackend = (backendCode: string) => {
    const serverUrl = process.env.VUE_APP_SERVER;
    let resultUrl = "";

    if (isSubDomainMultitenancyType) {

        const protocol = serverUrl?.split("/")[0];

        if (hasProtocol(protocol)) {
            resultUrl = serverUrl?.replace(`${protocol}//`, `${protocol}//${backendCode}.`) || "";
            if (resultUrl.endsWith("/")) {
                resultUrl = resultUrl.slice(0, -1);
            }
        }
        else {
            resultUrl = serverUrl || "";
        }
    }
    else {
        const protocol = serverUrl?.split("/")[0];

        if (hasProtocol(protocol)) {
            resultUrl = serverUrl + backendCode;
        }
        else {
            resultUrl = getServerUrlByRelativePath(serverUrl ?? "") + backendCode;
        }
    }

    return resultUrl;
}